import { Box } from '@mui/material';
import React from 'react';
import ProductOnboardingForm from '../../component/Layout/Versioning/OnBoardingProduct/OnboardingForm';

const Versioning = () => {
  return (
    <Box sx={{ padding: 0, backgroundColor: "white" }}>
      <ProductOnboardingForm/>
    </Box>
  );
};

export default Versioning;
